import createVueApp from '@/common/createApp'
import sidebar from '@/config/sidebars/adminSettings'

// Styxie derives name from Admin::Settings::CustomAlertsController → AdminSettingsCustomAlerts
Styxie.Initializers.AdminSettingsCustomAlerts = {
  index: async(props) => {
    const { default: IndexPage } = await import('@/vue_widgets/admin/settings/custom_alerts/index.vue')
    createVueApp(IndexPage, { props, sidebar })
  },
  new: async(props) => {
    const { default: NewPage } = await import('@/vue_widgets/admin/settings/custom_alerts/new.vue')
    createVueApp(NewPage, { props, sidebar })
  },
  edit: async(props) => {
    const { default: EditPage } = await import('@/vue_widgets/admin/settings/custom_alerts/edit.vue')
    createVueApp(EditPage, { props, sidebar })
  }
}
